// extracted by mini-css-extract-plugin
module.exports = {"dividerwrapper":"style_dividerwrapper__2wrkv","dividertext":"style_dividertext__-Q51G","mask":"style_mask__1QWtP","line":"style_line__2_BAn"};